import FacilitiesViewComponent from "../components/facilities/FacilitiesComponent";

export default function FacilitiesView(){
    
    return (
        <FacilitiesViewComponent />
    )
}